import styled from "styled-components";
import { Link } from 'react-router-dom'
// import { useState, useEffect } from "react";
// import axios from "axios";

const media ={
    desktop: '@media (min-width: 800px)',
    mobile: '@media (max-width: 780px)',
    phone: '@media (max-width: 580px)'
    }

export default function HomePage() {

    // const Signs = {
    //     a: 'Aries',
    //     t: 'Taurus',
    //     g: 'Gemini',
    //     c: 'Cancer',
    //     l: 'Leo',
    //     v: 'Virgo',
    //     li: 'Libra',
    //     s: 'Scorpio',
    //     sa: 'Sagittarius',
    //     ca: 'Capricorn',
    //     aq: 'Aquarius',
    //     p: 'Pisces'
    // }

    return(
        <StyledHome>
            <div className="astrology">
                <Link to="/aries" state={'Aries'}>
                <img alt="symbol for aries" src="https://img.icons8.com/ios/50/000000/aries.png"/>
                </Link>
                <Link to="/taurus" state={'Taurus'}>
                <img alt="symbol for taurus" src="https://img.icons8.com/ios/50/000000/taurus.png"/>
                </Link>
                <Link to="/gemini" state={'Gemini'}>
                <img alt="symbol for gemini" src="https://img.icons8.com/ios/50/000000/gemini.png"/>
                </Link>
                <Link to="/cancer" state={'Cancer'}>
                <img alt="symbol for cancer" src="https://img.icons8.com/ios/50/000000/cancer.png"/>
                </Link>
                <Link to="/leo" state={'Leo'}> 
                <img alt="symbol for leo" src="https://img.icons8.com/ios/50/000000/leo.png"/>
                </Link>
                <Link to="/virgo" state={'Virgo'}>
                <img alt="symbol for virgo" src="https://img.icons8.com/ios/50/000000/virgo.png"/>
                </Link>
                <Link to="/libra" state={'Libra'}>
                <img alt="symbol for libra" src="https://img.icons8.com/ios/50/000000/libra.png"/>
                </Link>
                <Link to="/scorpio" state={'Scorpio'}>
                <img alt="symbol for scorpio" src="https://img.icons8.com/ios/50/000000/scorpio.png"/>
                </Link>
                <Link to="/sagittarius" state={'Sagittarius'}>
                <img alt="symbol for sagittarius" src="https://img.icons8.com/ios/50/000000/sagittarius.png"/>
                </Link>
                <Link to="/capricorn" state={'Capricorn'}>
                <img alt="symbol for capricorn" src="https://img.icons8.com/ios/50/000000/capricorn.png"/>
                </Link>
                <Link to="/aquarius" state={'Aquarius'}>
                <img alt="symbol for aquarius" src="https://img.icons8.com/ios/50/000000/aquarius.png"/>
                </Link>
                <Link to="/pisces" state={'Pisces'}>
                <img alt="symbol for pisces" src="https://img.icons8.com/ios/50/000000/pisces.png"/>
                </Link>
            </div>
        </StyledHome>
    )
}

const StyledHome = styled.div`
width: 100%;
height: 90vh;

.astrology{
    margin-top: 5%;
    height: 80vh;
    display:flex ;
    justify-content:center ;
    align-items:center ;
    flex-wrap: wrap;

}

.astrology a{
    display:flex ;
    justify-content:center ;
    align-items: center;
    background-color: white;
    width: 7rem;
    height: 7rem ;
    margin: 3%;
    border-radius: 50%;
    box-shadow: inset 0em 0em .4em .3em rgba(50, 50, 50, 0.3), 0em 0em 1em .2em rgba(192, 192, 192, 0.3) ;
}

${media.phone}{
    .astrology a{
    width: 5rem;
    height: 5rem ;
    }
}
`